// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__JwqT6","button":"Menu_button__c1OpB","nav":"Menu_nav__aihPh","fade":"Menu_fade__CMzIG","menu-list":"Menu_menu-list__XB8Yi","link":"Menu_link__NlDAp"};